import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const g = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-tijiaogongdan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-æäº¤å·¥å"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M5.612 2.7A2.912 2.912 0 0 0 2.7 5.612v12.673a2.912 2.912 0 0 0 2.912 2.912h5.28a.8.8 0 0 0 0-1.6h-5.28A1.312 1.312 0 0 1 4.3 18.285V5.612c0-.725.588-1.312 1.312-1.312h10.776c.725 0 1.312.587 1.312 1.312v1.76a.8.8 0 1 0 1.6 0v-1.76A2.912 2.912 0 0 0 16.388 2.7H5.612Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M7.02 7.628a.8.8 0 1 0 0 1.6h7.04a.8.8 0 1 0 0-1.6H7.02Zm-.8 5.024a.8.8 0 0 1 .8-.8h4.225a.8.8 0 1 1 0 1.6H7.02a.8.8 0 0 1-.8-.8Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M13.508 20.449c-.137.95.956 1.581 1.71.988l1.912-1.504c.16-.126.293-.28.395-.456l3.997-6.924a2.005 2.005 0 1 0-3.473-2.005l-3.997 6.924a1.598 1.598 0 0 0-.197.57l-.347 2.407Zm2.694-1.695-1.054.83.191-1.328a.097.097 0 0 1 .012-.034l3.997-6.924a.505.505 0 0 1 .875.505l-3.997 6.924a.095.095 0 0 1-.024.027Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
